// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_dbe74d67","swiper":"_ff376ffe","item":"_a4c75fc1"};